// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"XI-z","smallCardRow":"YI-z","largeCardRow":"ZI-z","productSearchRow":"_I-z","curatedRow":"aJ-z"};